module.exports = __webpack_public_path__ + "media/images/athletes/2194-e24fdf8c4ac2215e0af790ccce75a81f.png";